<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar v-if="item" class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large class="mr-2"  >mdi-account</v-icon>{{ item['login'] }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div class="d-inline-flex">
        <v-btn
          class="ml-2"
          :to="{ name: 'UserList' }"
        >
          {{ $t('global.back')}}
        </v-btn>
        <v-btn
          class="ml-2"
          v-if="userHasAccess('user_unblock')"
          color="primary"
          @click="unblock"
        >
          {{ $t('administration.user.unblockuser')}}
        </v-btn>
        <v-btn
          class="ml-2"
          v-if="userHasAccess('user_password_init')"
          color="primary"
          :to="{ name: 'UserInitPassword' , params: { id: item['@id'] } }"
        >
          {{ $t('administration.user.initpassword')}}
        </v-btn>
        <v-btn
          class="ml-2"
          v-if="userHasAccess('user_edit')"
          color="primary"
          :to="{ name: 'UserUpdate' , params: { id: item['@id'] } }"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="item">
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.firstname') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ item['firstname'] }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.lastname') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ item['lastname'] }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.login') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ item['login'] }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.email') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ item['email'] }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.profil.profil') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ item['profil'].name }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.profil.profilinterface') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ item['profilInterface'].name }}</span>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.enabled') }}:</strong>
            </v-col>
            <v-col md="6">
              <span v-if="item.enabled" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
              <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.supervision') }}:</strong>
            </v-col>
            <v-col md="6">
              <span v-if="item.supervision" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
              <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('global.dateCreation') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ formatDateTime(item['dateCreation'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.lastlogin') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ formatDateTime(item['lastLogin'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.passwordrequestedat') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ formatDateTime(item['passwordRequestedAt'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('administration.user.dateblock') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ formatDateTime(item['dateDisable'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>

<script>
import { mapActions, mapGetters,mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
const servicePrefix = 'User';

export default {
  name: 'UserShow',
  servicePrefix,
  components: {
      Loading,
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields(['error', 'isLoading', 'violations']),
    ...mapState('user', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('user', ['find'])
  },
  methods: {
    ...mapActions('user', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    }),
    ...mapActions({
      userPushAction: 'user/action'
    }),
    unblock() {
      let action = 'user/'+this.item.id+'/edit/unblock';
        this.userPushAction({action: action,values: {
       }});
    },

    unblocked(item_return) {
      this.showMessage(item_return.message);
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      let action = 'user/'+this.item.id+'/edit/unblock';
      if (this.action == action) {
        this.unblocked(actioned);
      }
    },

    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
